import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { JoinComponent } from './pages/join/join.component';
import { ParticipateComponent } from './pages/participate/participate.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginGuard } from './guard/login.guard';
import { HomeComponent } from './pages/home/home.component';
import { SpinnerComponent } from './pages/spinner/spinner.component';
import { WheelComponent } from './pages/wheel/wheel.component';
import { MosaicComponent } from './pages/mosaic/mosaic.component';
import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    data: {
      title: "ERPat Rapol"
    }
  },
  {
    path: 'join/:id',
    component: JoinComponent
  },
  {
    path: 'bsei/:id',
    component: ParticipateComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'admin',
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'spinner',
        component: SpinnerComponent
      },
      {
        path: 'wheel',
        component: WheelComponent
      },
      {
        path: 'mosaic',
        component: MosaicComponent
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
